import React, { useContext } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { LayoutDashboard, ListTodo, PlusCircle, LogOut, BellRing, X, Settings } from 'lucide-react';
import { AuthContext } from '../context/AuthContext';

const Sidebar = ({ onCloseMobile }) => {
  const { logout } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="h-full flex flex-col relative bg-slate-900">
      <div className="p-6 flex-shrink-0">
        <div className="flex justify-between items-center mb-8">
          <div className="flex items-center space-x-3 text-indigo-400">
            <div className="p-2 bg-indigo-500/10 rounded-xl">
              <BellRing className="h-7 w-7" />
            </div>
            <span className="text-2xl font-black tracking-tight text-white">Trading Bot</span>
          </div>
          <button 
            onClick={onCloseMobile}
            className="lg:hidden p-2 text-slate-400 hover:text-white hover:bg-slate-800 rounded-lg transition-colors"
          >
            <X className="h-5 w-5" />
          </button>
        </div>
        
        <nav className="space-y-1.5 mt-4">
          <p className="px-4 text-xs font-semibold text-slate-500 uppercase tracking-wider mb-4 mt-8">Main Menu</p>
          
          <NavLink
            to="/"
            end
            onClick={onCloseMobile}
            className={({ isActive }) =>
              `flex items-center space-x-3 px-4 py-3.5 rounded-xl font-medium transition-all duration-200 group ${
                isActive 
                  ? 'bg-indigo-600 text-white shadow-lg shadow-indigo-500/25' 
                  : 'text-slate-400 hover:bg-slate-800 hover:text-white'
              }`
            }
          >
            <LayoutDashboard className={`h-5 w-5 transition-transform duration-200 group-hover:scale-110`} />
            <span>Dashboard</span>
          </NavLink>
          
          {/* Integration Link */}
          <NavLink
            to="/integration"
            onClick={onCloseMobile}
            className={({ isActive }) =>
              `flex items-center space-x-3 px-4 py-3.5 rounded-xl font-medium transition-all duration-200 group ${
                isActive 
                  ? 'bg-indigo-600 text-white shadow-lg shadow-indigo-500/25' 
                  : 'text-slate-400 hover:bg-slate-800 hover:text-white'
              }`
            }
          >
            <ListTodo className={`h-5 w-5 transition-transform duration-200 group-hover:scale-110`} />
            <span>MT5 Integration</span>
          </NavLink>

          <p className="px-4 text-xs font-semibold text-slate-500 uppercase tracking-wider mb-4 mt-8">Preferences</p>

          <NavLink
            to="/settings"
            onClick={onCloseMobile}
            className={({ isActive }) =>
              `flex items-center space-x-3 px-4 py-3.5 rounded-xl font-medium transition-all duration-200 group ${
                isActive 
                  ? 'bg-indigo-600 text-white shadow-lg shadow-indigo-500/25' 
                  : 'text-slate-400 hover:bg-slate-800 hover:text-white'
              }`
            }
          >
            <Settings className={`h-5 w-5 transition-transform duration-200 group-hover:scale-110`} />
            <span>Settings</span>
          </NavLink>
        </nav>
      </div>

      <div className="mt-auto p-6">
        <div className="bg-slate-800/50 rounded-2xl p-4 mb-6 border border-slate-700/50 backdrop-blur-sm">
          <p className="text-sm text-slate-300 font-medium mb-1">Need help?</p>
          <p className="text-xs text-slate-500 mb-3">Message the bot on Telegram for commands.</p>
          <a href="https://t.me/Vikas_reminder_bot" target="_blank" rel="noreferrer" className="block text-center w-full bg-slate-700 hover:bg-slate-600 text-white text-xs font-semibold py-2 px-4 rounded-lg transition-colors">
            Open Telegram
          </a>
        </div>

        <button
          onClick={handleLogout}
          className="flex items-center justify-center space-x-2 px-4 py-3.5 w-full rounded-xl text-slate-400 hover:bg-red-500/10 hover:text-red-400 transition-colors font-medium border border-transparent hover:border-red-500/20"
        >
          <LogOut className="h-5 w-5" />
          <span>Logout</span>
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
